module.exports = __webpack_public_path__ + "static/media/expressiveBubbleGum-large.75727caf.jpg";